import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script";

class PostGrid extends BasePostGrid {
    init() {
        super.init();

        window.addEventListener("pegasus-grid-filter-toggle", (event) => {
            this.currentFilters = event.detail.currentFilters;
            this.fetchContent();
        });
    }

    // Don't reload the page on filter remove

    fetchContent(href = null) {
        // Get the post grid container and the data selector for the post grid.
        const postGrid = this.postGrid.querySelector(
            "[data-pegasus-filterable]"
        );
        const elements = [
            'data-pegasus-filterable="' +
                postGrid.dataset.pegasusFilterable +
                '"',
        ];
        let currentUrl = "";

        currentUrl = this.buildUrl();

        // If a href is passed in, use that instead of the current url.
        if (href) {
            currentUrl = href;
        }

        // Only allow a request to happen whilst we're not waiting for a response.
        if (!this.isLoading) {
            this.isLoading = true;

            // Run the ajaxContent function from pegasus.
            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;

                // Update the url with the current filters.
                history.pushState(
                    JSON.stringify(this.currentFilters),
                    "",
                    currentUrl
                );

                // Scroll to the top of the post grid.
                //pegasus.scroll(this.postGrid);

                // If the post grid items open in modals make sure to re-initialise them.
                if (typeof window.modal !== "undefined") {
                    window.modal.init();
                }
            });
        }
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGrid", () => new PostGrid());
});
